import { render, staticRenderFns } from "./WaitDialog.vue?vue&type=template&id=4ebef0c0&scoped=true"
import script from "./WaitDialog.vue?vue&type=script&lang=js"
export * from "./WaitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebef0c0",
  null
  
)

export default component.exports